// Statische kopie van onze Google reviews.
// Deze data wordt direct in de eerste render (en dus in de statische HTML)
// meegegeven, zodat crawlers/AI-engines die geen JavaScript uitvoeren de
// reviews kunnen lezen. De live Google Places API verrijkt dit daarna alleen.

export type StaticReview = {
  rating: number;
  text: string;
  relativeTime: string;
  publishTime: string;
  author: { name: string; photo: string; profileUri: string };
  reviewUri: string;
};

export const GOOGLE_RATING = 5.0;
export const GOOGLE_REVIEW_COUNT = 21;
export const GOOGLE_MAPS_URI = "https://www.google.com/maps/search/?api=1&query=PlayfieldVR";

export const staticReviews: StaticReview[] = [
  {
    rating: 5,
    text: "Enthusiastic team which provides an amazing virtual experience on-site resulting in a bunch of fun amongst participants.",
    relativeTime: "",
    publishTime: "",
    author: { name: "Ralph Meeuws", photo: "", profileUri: "" },
    reviewUri: "",
  },
  {
    rating: 5,
    text: "Never laughed so hard at an office party! Highly recommend if you are looking to have a fun time!",
    relativeTime: "",
    publishTime: "",
    author: { name: "Eunice Wong", photo: "", profileUri: "" },
    reviewUri: "",
  },
  {
    rating: 5,
    text: "Great quality of games and equipment! Had a lot of fun shooting cyborgs and cooking burgers with my colleagues.",
    relativeTime: "",
    publishTime: "",
    author: { name: "Melanie Briggeman", photo: "", profileUri: "" },
    reviewUri: "",
  },
  {
    rating: 5,
    text: "Tried this VR set at a corporate event and really enjoyed it! Incredibly immersive and interactive — the highlight of the evening.",
    relativeTime: "",
    publishTime: "",
    author: { name: "Rensie Kes-Kuijlaars", photo: "", profileUri: "" },
    reviewUri: "",
  },
];
